import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GiHouse } from "react-icons/gi";
import { FaDownload } from "react-icons/fa6";
import axios from "axios";
import { API_URL } from "../../Config";

// import { QuickBrochureData } from "../../Config";

const QuickBrochure = () => {
  const navigate = useNavigate();
  const { propertyid } = useParams();

  const [propertyData, setPropertyData] = useState(null);
  const fixImageType = (img) => {
    if (!img) return null;

    if (img.startsWith("data:image/png;base64,PD94")) {
      return img.replace("data:image/png", "data:image/svg+xml");
    }

    return img;
  };
  useEffect(() => {
    const fetchProperty = async () => {
      try {
        const res = await axios.get(`${API_URL}/id/${propertyid}`);

        if (res.data.success) {
          setPropertyData(res.data);
        }
      } catch (error) {
        console.error("Error fetching property:", error);
      }
    };

    fetchProperty();
  }, [propertyid]);
  if (!propertyData) {
    return (
      <div className="flex justify-center items-center h-screen text-xl">
        Loading Brochure...
      </div>
    );
  }
  const QuickBrochureData = [
    {
      id: 1,
      villa: {
        logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
        title: "House of Basho",
        text: "Explore a luxury villa.",
        mainImage:
          "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9b13702d-d1cd-4dee-db7b-41283ea42600/public",
        signature: "Arpora, North Goa",
        contact: {
          website: "www.zorbastays.com",
          email: "info@zorbastays.com",
          phones: "63552-31066, 98750-28066",
        },
      },

      amenities: {
        logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",

        items: [
          {
            name: "Twin Serenity Pools",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/38baf459-b4a1-46a8-07b3-f44a552d5700/public",
          },
          {
            name: "5 EN-SUITE BEDROOMS",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/06e7dd94-ed3d-4b6e-15d4-f2217c3cf900/public",
          },
          {
            name: "Private Chef on Call",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f3d9b4f4-5b09-4d81-7ab6-089ed2823300/public",
          },
          {
            name: "SCENIC VIEWS",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5e713758-7d3d-4060-33fb-721ad7532e00/public",
          },
          {
            name: "WIFI",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/1a095f92-8093-44d6-8865-87528b883400/public",
          },
          {
            name: "GARDENS AND OUTDOOR SPACES",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/196104dc-f22e-4bc4-a0e7-54876564b200/public",
          },
          {
            name: "KITCHEN ESSENTIALS",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/82b84600-29c2-4c6a-dba0-b693efa3ee00/public",
          },
          {
            name: "POWER BACKUP",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/66c1654e-17e2-429a-ef3c-8edb9fbfbc00/public",
          },
          {
            name: "EVENING TURNDOWN service",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/b7f24198-46a9-4d9d-5677-899fa62cf300/public",
          },
          {
            name: "TOWELS AND TOILETRIES",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d931ddba-e976-439f-01c8-d09cb9a09500/public",
          },
        ],
      },

      theVilla: {
        logo: "https://zorbastays.com/android-chrome-512x512.png",

        image:
          "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7fab0b88-0aa1-405c-f458-6fb18fae3300/public",

        paragraph1:
          "Nestled in the serene locale of Lotoulim, South Goa, Villa ZST-G-807 is a beautifully laid-out 8-bedroom retreat designed for comfort and leisure. Each en-suite bedroom offers privacy and modern amenities, while the shared swimming pool, garden, and expansive lawn create inviting spaces for relaxation. The villa features a fully equipped kitchen, cozy living areas, and an inviting bar, complemented by indoor games for entertainment.",
        paragraph2: "Your Private Forest-View Sanctuary Awaits",
      },

      services: {
        section1: {
          title: "Feel Every destination",
          description:
            "We go beyond stays — we craft journeys. Whether you're an Indian traveler rediscovering your own country or a global guest exploring its essence for the first time, our travel guides help you experience each destination through local eyes. From curated recommendations on where to go and what to taste, to hidden gems known only to the locals, we ensure you feel the true rhythm of every state. Think of us as your personal storytellers, guiding you through India's culture, landscapes, and soul — one unforgettable stay at a time.",
          bannerText: "Check Travel Guide for Your Stay",
        },
        section2: {
          title: "Concierge at Your service",
          description:
            "We believe the finest journeys come with thoughtful care. Our concierge service is here to make every moment effortless — from arranging local experiences and private transfers to curating special dining or celebration moments. Whether you're an Indian guest or a traveler from afar, our team ensures every detail feels personal and seamless. Just tell us what you need, and we'll make it happen — with warmth, precision, and a touch of Zorba charm.",
          bannerText: "Explore Concierge services",
        },
      },

      aboutZorba: {
        title: "About Zorba",

        heading: "Find your self in nature.",

        paragraph1:
          "Zorba was born from the slow realization that everyone we've assisted or known over the years, have all wanted very different kinds of travel experiences. But even with all the differences, what anchored them together was the singular belief in the human & nature connection, a belief that there can be very few pleasures as universal and as pure as the simple feeling of sand between your toes on a beach or the sensation of walking barefoot on fresh green grass.",
        paragraph2:
          "This has become our attempt with Zorba Stays, to assist people in having an honest beautiful experience that they've always wanted.",
        paragraph3:
          "Zorba Stays is our hope to assist people in exploring the beautiful landscapes of our country, from the warm beaches of Goa to the serene valleys of Uttarakhand and beyond. Whether someone is looking for meditation or a collective celebration- a marriage or a party, we want to invite everyone, as long as they're seeking an honest, beautiful experience. Come explore with us and realize this dream together at Zorba Stays.",
      },

      backCover: {
        logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
        quoteLine1: "Indulge in the extraordinary;",
        quoteLine2: "life's too short for ordinary",
        contact: {
          website: "www.zorbastays.com",
          email: "info@zorbastays.com",
          phones: "63552-31066, 98750-28066",
        },
      },
    },

    {
      id: 2,
      villa: {
        logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
        title: "House of Tao",
        text: "Explore a luxury villa.",
        mainImage:
          "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/130fb347-db03-45f7-5519-4bc0cdf04d00/public",
        signature: "Arpora, North Goa",
        contact: {
          website: "www.zorbastays.com",
          email: "info@zorbastays.com",
          phones: "63552-31066, 98750-28066",
        },
      },
      amenities: {
        logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",

        items: [
          {
            name: "Twin Serenity Pools",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/38baf459-b4a1-46a8-07b3-f44a552d5700/public",
          },
          {
            name: "5 EN-SUITE BEDROOMS",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/06e7dd94-ed3d-4b6e-15d4-f2217c3cf900/public",
          },
          {
            name: "Private Chef on Call",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f3d9b4f4-5b09-4d81-7ab6-089ed2823300/public",
          },
          {
            name: "SCENIC VIEWS",
            imgSrc:
              "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5e713758-7d3d-4060-33fb-721ad7532e00/public",
          },
        ],
      },

      theVilla: {
        logo: "https://zorbastays.com/android-chrome-512x512.png",

        image:
          "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/130fb347-db03-45f7-5519-4bc0cdf04d00/public",

        paragraph1:
          "Nestled in the serene locale of Lotoulim, South Goa, Villa ZST-G-807 is a beautifully laid-out 8-bedroom retreat designed for comfort and leisure. Each en-suite bedroom offers privacy and modern amenities, while the shared swimming pool, garden, and expansive lawn create inviting spaces for relaxation. The villa features a fully equipped kitchen, cozy living areas, and an inviting bar, complemented by indoor games for entertainment.",
        paragraph2: "Your Private Forest-View Sanctuary Awaits",
      },

      services: {
        section1: {
          title: "Feel Every destination",
          description:
            "We go beyond stays — we craft journeys. Whether you're an Indian traveler rediscovering your own country or a global guest exploring its essence for the first time, our travel guides help you experience each destination through local eyes. From curated recommendations on where to go and what to taste, to hidden gems known only to the locals, we ensure you feel the true rhythm of every state. Think of us as your personal storytellers, guiding you through India's culture, landscapes, and soul — one unforgettable stay at a time.",
          bannerText: "Check Travel Guide for Your Stay",
        },
        section2: {
          title: "Concierge at Your service",
          description:
            "We believe the finest journeys come with thoughtful care. Our concierge service is here to make every moment effortless — from arranging local experiences and private transfers to curating special dining or celebration moments. Whether you're an Indian guest or a traveler from afar, our team ensures every detail feels personal and seamless. Just tell us what you need, and we'll make it happen — with warmth, precision, and a touch of Zorba charm.",
          bannerText: "Explore Concierge services",
        },
      },

      aboutZorba: {
        title: "About Zorba",

        heading: "Find your self in nature.",

        paragraph1:
          "Zorba was born from the slow realization that everyone we've assisted or known over the years, have all wanted very different kinds of travel experiences. But even with all the differences, what anchored them together was the singular belief in the human & nature connection, a belief that there can be very few pleasures as universal and as pure as the simple feeling of sand between your toes on a beach or the sensation of walking barefoot on fresh green grass.",
        paragraph2:
          "This has become our attempt with Zorba Stays, to assist people in having an honest beautiful experience that they've always wanted.",
        paragraph3:
          "Zorba Stays is our hope to assist people in exploring the beautiful landscapes of our country, from the warm beaches of Goa to the serene valleys of Uttarakhand and beyond. Whether someone is looking for meditation or a collective celebration- a marriage or a party, we want to invite everyone, as long as they're seeking an honest, beautiful experience. Come explore with us and realize this dream together at Zorba Stays.",
      },

      backCover: {
        logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
        quoteLine1: "Indulge in the extraordinary;",
        quoteLine2: "life's too short for ordinary",
        contact: {
          website: "www.zorbastays.com",
          email: "info@zorbastays.com",
          phones: "63552-31066, 98750-28066",
        },
      },
    },
  ];

  const Property = QuickBrochureData[0];

  const property = propertyData.property;
  const images = propertyData.propertyImages;
  const experiences = propertyData.experiences;
  const amenities = [
    { name: experiences.exptitle, imgSrc: experiences.expimage },
    { name: experiences.exptitle2, imgSrc: experiences.expimage2 },
    { name: experiences.exptitle3, imgSrc: experiences.expimage3 },
    { name: experiences.exptitle4, imgSrc: experiences.expimage4 },
    { name: experiences.exptitle5, imgSrc: experiences.expimage5 },
    { name: experiences.exptitle6, imgSrc: experiences.expimage6 },
    { name: experiences.exptitle7, imgSrc: experiences.expimage7 },
    { name: experiences.exptitle8, imgSrc: experiences.expimage8 },
  ]
    .filter((item) => item.name && item.imgSrc)
    .map((item) => ({
      ...item,
      imgSrc: fixImageType(item.imgSrc),
    }));
  const villaImages = [
    images.banner3,
    images.banner4,
    images.banner5,
    images.img1_c1,
    images.img2_c1,
    images.img3_c1,
    images.img1_c2,
    images.img2_c2,
    images.img3_c2,
    images.img4_c2,
    images.img5_c2,
    images.img1_c3,
    images.img2_c3,
    images.img3_c3,
    images.img4_c3,
    images.img5_c3,
  ].filter(Boolean);
  const handleDownload = () => {
    window.print();
  };
  if (!propertyData) {
    return <div className="p-20 text-center">Loading Brochure...</div>;
  }
  return (
    <div className="bg-white min-h-screen flex flex-col items-center py-10 gap-10 print:gap-0 print:py-0 print:p-0 print:bg-[#f8f7f6]">
      {/* DOWNLOAD BUTTON */}
      <div className="fixed right-5 bottom-14 flex justify-center py-6 print:hidden">
        <button
          onClick={handleDownload}
          className="flex gap-2 justify-center items-center bg-black text-white w-48 py-3 rounded-md tracking-widest text-sm hover:bg-green-800 transition duration-200 ease-linear"
        >
          <FaDownload />
          Download PDF
        </button>
      </div>

      <div className="fixed right-5 bottom-1 flex justify-center py-6 print:hidden">
        <button
          onClick={() => navigate("/Properties")}
          className="flex gap-2 justify-center items-center border-2 border-black text-black font-semibold w-48 py-2.5 rounded-md tracking-widest text-sm hover:bg-black hover:text-white transition duration-200 ease-linear"
        >
          <GiHouse />
          Back to Properties
        </button>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
            @page {
              size: A4 portrait;
              margin: 0;
            }

            @media print {
              html, body {
                width: 210mm;
                margin: 0;
                padding: 0;
                height: auto !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              body {
                zoom: 100%;
              }

              .print-page {
                width: 210mm !important;
                min-height: 297mm !important;
                page-break-after: always;
                break-after: page;
                page-break-inside: avoid;
                break-inside: avoid;
                margin: 0 !important;
              }

              .print-page:last-of-type {
                page-break-after: auto !important;
                break-after: auto !important;
              }

              .shadow-md {
                box-shadow: none !important;
              }
            }
          `,
        }}
      />

      {/* COVER */}
      <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative flex flex-col items-center p-12">
        <div className="absolute top-0 left-12 w-[1px] h-80 bg-gray-400"></div>
        <div className="absolute top-0 left-20 w-[1px] h-60 bg-gray-400"></div>

        <div className="mt-8 flex flex-col items-center">
          <img
            src={Property.villa.logo}
            alt={Property.villa.title}
            className="h-28 w-auto object-contain"
          />
        </div>
        {/* coming from api as propertyname */}
        <h2 className="mt-20 text-4xl PlayfairDisplay text-gray-800 tracking-wide ">
          {property.propertyname}
        </h2>

        <div className="mt-24 w-full relative group px-4">
          <p className="montserrat absolute -top-4 right-4 text-[10px] tracking-[0.2em] text-gray-800 uppercase">
            Explore a luxury villa.
          </p>
          {/* coming from api as banner1 */}
          <div className="w-full aspect-[4/3] bg-gray-200 overflow-hidden">
            <img
              src={images.banner1}
              alt={property.propertyname}
              className="w-full h-full object-cover"
            />
          </div>
          {/* coming from api as location , destination */}
          <div className="absolute -mt-2 right-0 transform z-10">
            <span className="windsong italic text-5xl text-gray-900">
              {property.location}, {property.destination}
            </span>
          </div>
        </div>

        <div className="montserrat absolute bottom-3">
          <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
            <a
              href={`https://zorbastays.com/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>www.zorbastays.com</span>
            </a>

            <span className="h-3 w-[1px] bg-gray-400"></span>

            <a href={`mailto:info@zorbastays.com`}>
              <span>info@zorbastays.com</span>
            </a>

            <span className="h-3 w-[1px] bg-gray-400"></span>

            <span>63552-31066, 98750-28066</span>
          </div>
        </div>
      </div>
      {/* Get AMENITIES from expimage,expimage2,expimage3,expimage4...expimage8 and exptitle,exptitle2,exptitle3...exptitle8 note:only show amenities which are !null*/}

      {/* AMENITIES */}
      {Array.from({ length: Math.ceil(amenities.length / 10) }, (_, i) =>
        amenities.slice(i * 10, i * 10 + 10),
      ).map((amenityGroup, pageIndex, allPages) => (
        <div
          key={pageIndex}
          className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative flex flex-col"
        >
          {pageIndex === 0 && (
            <div className="mt-8 ml-6 flex-none">
              <h1 className="text-3xl font-serif italic text-gray-800">The</h1>
              <h2 className="text-5xl PlayfairDisplay tracking-widest text-gray-800 uppercase mt-2">
                Amenities
              </h2>
            </div>
          )}

          <div
            className={`flex-grow flex items-start justify-center ${pageIndex === 0 ? "pt-20" : "pt-32"}`}
          >
            <div className="grid grid-cols-2 gap-y-12 gap-x-12 px-4 w-full">
              {amenityGroup.map((item, index) => (
                <div key={index} className="flex items-center space-x-6">
                  <div className="w-24 h-24 flex items-center justify-center flex-none">
                    <img
                      src={
                        item.imgSrc?.startsWith("data:")
                          ? item.imgSrc
                          : `data:image/png;base64,${item.imgSrc}`
                      }
                      alt={item.name}
                      className="max-w-full max-h-full object-contain brightness-0 grayscale"
                    />
                  </div>
                  <span className="text-[11px] font-medium tracking-[0.2em] uppercase text-gray-800 leading-tight">
                    {item.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
          {pageIndex === allPages.length - 1 && (
            <div className="mt-auto mb-4 flex justify-center items-center space-x-4">
              <div className="w-12 h-[1px] bg-gray-400"></div>
              <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
                <img
                  src={Property?.amenities?.logo || "/logo.png"}
                  alt="logo"
                  className="w-8 h-5 brightness-0"
                />
              </div>
              <div className="w-12 h-[1px] bg-gray-400"></div>
            </div>
          )}
        </div>
      ))}

      {/* THE VILLA */}
      <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
        {(() => {
          const totalChars =
            (Property.theVilla.paragraph1?.length || 0) +
            (Property.theVilla.paragraph2?.length || 0);

          const imageBottom =
            totalChars > 600 ? "bottom-[40px]" : "bottom-[170px]";
          const logoBottom =
            totalChars > 600 ? "bottom-[20px]" : "bottom-[70px]";

          return (
            <>
              <div className="mb-8 ml-5">
                <h1 className="text-3xl font-serif italic text-gray-800 leading-tight">
                  The
                </h1>
                <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2">
                  Villa
                </h2>
              </div>

              <div
                className="montserrat flex flex-col ml-5 space-y-6 text-gray-800 tracking-widest text-base text-justify max-w-[92%]"
                style={{ wordSpacing: "1px" }}
              >
                {/* comes from apis as content */}
                <p> {property.content}</p>
                {/* comes from apis as heading */}
                <p>{property.heading}</p>
              </div>

              {/* comes from apis as banner2 */}
              <div
                className={`absolute left-12 right-12 h-[430px] z-20 ${imageBottom}`}
              >
                <img
                  src={images.banner2}
                  alt="Villa Exterior"
                  className="w-full h-full object-cover"
                />
              </div>

              <div
                className={`absolute left-8 w-28 h-28 opacity-20 grayscale z-10 ${logoBottom}`}
              >
                <img
                  src={Property.theVilla.logo}
                  alt="Logo Watermark"
                  className="w-full h-full object-contain"
                />
              </div>
            </>
          );
        })()}
      </div>
      {/* add remaining images url from banner3,banner4,banner5,imagegrid1,imagegrid2,imagegrid3,img1_c1,img2_c1,img3_c1,img4_c1,img5_c1,img1_c2,img2_c2,img3_c2,img4_c2,img5_c2,img1_c3,img2_c3,img3_c3,img4_c3,img5_c3,img1_c4,img2_c4,img3_c4,img4_c4,img5_c4,img1_c5,img2_c5,img3_c5,img4_c5,img5_c5 */}
      {/* GALLERY */}
      {(function () {
        let pages = [];
        let i = 0;

        while (i < villaImages.length) {
          pages.push({
            images: villaImages.slice(i, i + 2),
          });

          i = i + 2;
        }

        return pages.map(function (p, pageIndex) {
          return (
            <div
              key={pageIndex}
              className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] relative overflow-hidden px-8 pt-16 flex flex-col gap-4 shadow-md"
            >
              {p.images.map(function (src, i) {
                return (
                  <div
                    key={i}
                    className="flex-1 flex justify-center overflow-hidden"
                  >
                    <img
                      src={src}
                      alt="villa"
                      className="w-auto"
                      style={{ maxHeight: "450px" }}
                    />
                  </div>
                );
              })}
            </div>
          );
        });
      })()}
      {/* Stays same for all properties */}
      {/* serviceS */}
      <div className="print-page w-[210mm] min-h-[297mm] px-12 pt-20 flex flex-col relative bg-[#f8f7f6] shadow-md">
        <div className="mb-12 max-w-[92%] ml-5">
          <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-6">
            {Property.services.section1.title}
          </h2>
          <p
            className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-10"
            style={{ wordSpacing: "1px" }}
          >
            {Property.services.section1.description}
          </p>

          <div
            className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-center"
            style={{
              backgroundImage:
                "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
            }}
          >
            <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
            <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
              {Property.services.section1.bannerText}
            </h3>
            <a
              href="https://drive.google.com/file/d/1jOhgd_mzOigpKwZ9ZCWaVt_iyguQlFKa/view"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
                Click Here
              </button>
            </a>
          </div>
        </div>

        <div className="max-w-[92%] ml-5">
          <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-10 mt-10">
            {Property.services.section2.title}
          </h2>
          <p
            className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-8"
            style={{ wordSpacing: "1px" }}
          >
            {Property.services.section2.description}
          </p>

          <div
            className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-top"
            style={{
              backgroundImage:
                "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
            }}
          >
            <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
            <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
              {Property.services.section2.bannerText}
            </h3>
            <a
              href="https://drive.google.com/file/d/1jOhgd_mzOigpKwZ9ZCWaVt_iyguQlFKa/view"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
                Click Here
              </button>
            </a>
          </div>
        </div>
      </div>

      {/* ABOUT ZORBA */}
      <div className="print-page w-[210mm] min-h-[297mm] relative flex flex-col pt-10 px-8 overflow-hidden bg-[#f8f7f6] shadow-md">
        <div className="absolute top-10 right-12 z-20 flex items-center justify-end w-full">
          <div className="flex-1 h-[1px] bg-gray-400 ml-0"></div>

          <span className="waterfall italic text-7xl text-gray-800 pl-6">
            {Property.aboutZorba.title || "About"}
          </span>
        </div>

        <div className="absolute top-32 bottom-0 right-12 w-[1px] bg-gray-400"></div>

        <div className="flex flex-col justify-center h-full max-w-[95%] pr-16 pl-8 pt-[40vh]">
          <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-8 leading-tight">
            {Property.aboutZorba.heading}
          </h2>

          <div
            className="montserrat flex flex-col space-y-8 text-gray-800 text-[15px] tracking-widest text-justify"
            style={{ wordSpacing: "1px" }}
          >
            <p>{Property.aboutZorba.paragraph1}</p>
            <p>{Property.aboutZorba.paragraph2}</p>
            <p>{Property.aboutZorba.paragraph3}</p>
          </div>
        </div>
      </div>

      {/* BACK COVER */}
      <div className="print-page w-[210mm] min-h-[297mm] flex flex-col justify-between items-center py-16 px-12 bg-[#f8f7f6] shadow-md relative">
        <div className="flex flex-col items-center mt-60">
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public"
            alt="Logo"
            className="h-44 w-auto object-contain"
          />
        </div>

        <div className="flex flex-col items-center space-y-32">
          <div className="text-center">
            <span className="waterfall text-7xl block leading-tight">
              {Property.backCover.quoteLine1}
            </span>
            <span className="waterfall text-6xl block leading-tight">
              {Property.backCover.quoteLine2}
            </span>
          </div>

          <div className="montserrat flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
            <a
              href={`https://zorbastays.com/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {Property.backCover.contact.website}
            </a>

            <span className="h-3 w-[1px] bg-gray-400"></span>

            <a href={`mailto:info@zorbastays.com`}>
              {Property.backCover.contact.email}
            </a>

            <span className="h-3 w-[1px] bg-gray-400"></span>

            <span>{Property.backCover.contact.phones}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickBrochure;
//=====================================================Old Code==========================================================
// import React from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { GiHouse } from "react-icons/gi";
// import { FaDownload } from "react-icons/fa6";

// // import { QuickBrochureData } from "../../Config";

// const QuickBrochure = () => {
//   const navigate = useNavigate();
//   const { propertyid } = useParams();

//   console.log(propertyid);

//   const QuickBrochureData = [
//     {
//       id: 1,
//       villa: {
//         logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
//         title: "House of Basho",
//         text: "Explore a luxury villa.",
//         mainImage:
//           "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9b13702d-d1cd-4dee-db7b-41283ea42600/public",
//         signature: "Arpora, North Goa",
//         contact: {
//           website: "www.zorbastays.com",
//           email: "info@zorbastays.com",
//           phones: "63552-31066, 98750-28066",
//         },
//       },

//       amenities: {
//         logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",

//         items: [
//           {
//             name: "Twin Serenity Pools",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/38baf459-b4a1-46a8-07b3-f44a552d5700/public",
//           },
//           {
//             name: "5 EN-SUITE BEDROOMS",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/06e7dd94-ed3d-4b6e-15d4-f2217c3cf900/public",
//           },
//           {
//             name: "Private Chef on Call",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f3d9b4f4-5b09-4d81-7ab6-089ed2823300/public",
//           },
//           {
//             name: "SCENIC VIEWS",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5e713758-7d3d-4060-33fb-721ad7532e00/public",
//           },
//           {
//             name: "WIFI",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/1a095f92-8093-44d6-8865-87528b883400/public",
//           },
//           {
//             name: "GARDENS AND OUTDOOR SPACES",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/196104dc-f22e-4bc4-a0e7-54876564b200/public",
//           },
//           {
//             name: "KITCHEN ESSENTIALS",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/82b84600-29c2-4c6a-dba0-b693efa3ee00/public",
//           },
//           {
//             name: "POWER BACKUP",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/66c1654e-17e2-429a-ef3c-8edb9fbfbc00/public",
//           },
//           {
//             name: "EVENING TURNDOWN service",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/b7f24198-46a9-4d9d-5677-899fa62cf300/public",
//           },
//           {
//             name: "TOWELS AND TOILETRIES",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/d931ddba-e976-439f-01c8-d09cb9a09500/public",
//           },
//         ],
//       },

//       theVilla: {
//         logo: "https://zorbastays.com/android-chrome-512x512.png",

//         image:
//           "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7fab0b88-0aa1-405c-f458-6fb18fae3300/public",

//         paragraph1:
//           "Nestled in the serene locale of Lotoulim, South Goa, Villa ZST-G-807 is a beautifully laid-out 8-bedroom retreat designed for comfort and leisure. Each en-suite bedroom offers privacy and modern amenities, while the shared swimming pool, garden, and expansive lawn create inviting spaces for relaxation. The villa features a fully equipped kitchen, cozy living areas, and an inviting bar, complemented by indoor games for entertainment.",
//         paragraph2: "Your Private Forest-View Sanctuary Awaits",
//       },

//       villaImages: [
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7fab0b88-0aa1-405c-f458-6fb18fae3300/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/c83f64a1-77ff-4ad6-03a8-9897cf009300/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e3a84e6e-a637-4a05-7451-cc3477bf9900/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/70e931de-76ab-4ba2-8fab-d0fd47206700/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/24b2f064-db57-450d-da95-fd4e84e8b200/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7dc55a67-025e-4574-df41-2c5246a45300/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/3890ab6b-49cc-4099-6562-57fed96a0100/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/5ddf82c0-9eae-4d96-2e4b-fcac00d6e600/public",
//       ],

//       services: {
//         section1: {
//           title: "Feel Every destination",
//           description:
//             "We go beyond stays — we craft journeys. Whether you're an Indian traveler rediscovering your own country or a global guest exploring its essence for the first time, our travel guides help you experience each destination through local eyes. From curated recommendations on where to go and what to taste, to hidden gems known only to the locals, we ensure you feel the true rhythm of every state. Think of us as your personal storytellers, guiding you through India's culture, landscapes, and soul — one unforgettable stay at a time.",
//           bannerText: "Check Travel Guide for Your Stay",
//         },
//         section2: {
//           title: "Concierge at Your service",
//           description:
//             "We believe the finest journeys come with thoughtful care. Our concierge service is here to make every moment effortless — from arranging local experiences and private transfers to curating special dining or celebration moments. Whether you're an Indian guest or a traveler from afar, our team ensures every detail feels personal and seamless. Just tell us what you need, and we'll make it happen — with warmth, precision, and a touch of Zorba charm.",
//           bannerText: "Explore Concierge services",
//         },
//       },

//       aboutZorba: {
//         title: "About Zorba",

//         heading: "Find your self in nature.",

//         paragraph1:
//           "Zorba was born from the slow realization that everyone we've assisted or known over the years, have all wanted very different kinds of travel experiences. But even with all the differences, what anchored them together was the singular belief in the human & nature connection, a belief that there can be very few pleasures as universal and as pure as the simple feeling of sand between your toes on a beach or the sensation of walking barefoot on fresh green grass.",
//         paragraph2:
//           "This has become our attempt with Zorba Stays, to assist people in having an honest beautiful experience that they've always wanted.",
//         paragraph3:
//           "Zorba Stays is our hope to assist people in exploring the beautiful landscapes of our country, from the warm beaches of Goa to the serene valleys of Uttarakhand and beyond. Whether someone is looking for meditation or a collective celebration- a marriage or a party, we want to invite everyone, as long as they're seeking an honest, beautiful experience. Come explore with us and realize this dream together at Zorba Stays.",
//       },

//       backCover: {
//         logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
//         quoteLine1: "Indulge in the extraordinary;",
//         quoteLine2: "life's too short for ordinary",
//         contact: {
//           website: "www.zorbastays.com",
//           email: "info@zorbastays.com",
//           phones: "63552-31066, 98750-28066",
//         },
//       },
//     },

//     {
//       id: 2,
//       villa: {
//         logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4289f22-91de-411f-d677-6e92f843ea00/public",
//         title: "House of Tao",
//         text: "Explore a luxury villa.",
//         mainImage:
//           "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/130fb347-db03-45f7-5519-4bc0cdf04d00/public",
//         signature: "Arpora, North Goa",
//         contact: {
//           website: "www.zorbastays.com",
//           email: "info@zorbastays.com",
//           phones: "63552-31066, 98750-28066",
//         },
//       },
//       amenities: {
//         logo: "https://zorbastays.com/ZORBA_logo_iconGreen.webp",

//         items: [
//           {
//             name: "Twin Serenity Pools",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/38baf459-b4a1-46a8-07b3-f44a552d5700/public",
//           },
//           {
//             name: "5 EN-SUITE BEDROOMS",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/06e7dd94-ed3d-4b6e-15d4-f2217c3cf900/public",
//           },
//           {
//             name: "Private Chef on Call",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f3d9b4f4-5b09-4d81-7ab6-089ed2823300/public",
//           },
//           {
//             name: "SCENIC VIEWS",
//             imgSrc:
//               "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5e713758-7d3d-4060-33fb-721ad7532e00/public",
//           },
//         ],
//       },

//       theVilla: {
//         logo: "https://zorbastays.com/android-chrome-512x512.png",

//         image:
//           "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/130fb347-db03-45f7-5519-4bc0cdf04d00/public",

//         paragraph1:
//           "Nestled in the serene locale of Lotoulim, South Goa, Villa ZST-G-807 is a beautifully laid-out 8-bedroom retreat designed for comfort and leisure. Each en-suite bedroom offers privacy and modern amenities, while the shared swimming pool, garden, and expansive lawn create inviting spaces for relaxation. The villa features a fully equipped kitchen, cozy living areas, and an inviting bar, complemented by indoor games for entertainment.",
//         paragraph2: "Your Private Forest-View Sanctuary Awaits",
//       },

//       villaImages: [
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7fab0b88-0aa1-405c-f458-6fb18fae3300/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/c83f64a1-77ff-4ad6-03a8-9897cf009300/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e3a84e6e-a637-4a05-7451-cc3477bf9900/public",
//         "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/70e931de-76ab-4ba2-8fab-d0fd47206700/public",
//       ],

//       services: {
//         section1: {
//           title: "Feel Every destination",
//           description:
//             "We go beyond stays — we craft journeys. Whether you're an Indian traveler rediscovering your own country or a global guest exploring its essence for the first time, our travel guides help you experience each destination through local eyes. From curated recommendations on where to go and what to taste, to hidden gems known only to the locals, we ensure you feel the true rhythm of every state. Think of us as your personal storytellers, guiding you through India's culture, landscapes, and soul — one unforgettable stay at a time.",
//           bannerText: "Check Travel Guide for Your Stay",
//         },
//         section2: {
//           title: "Concierge at Your service",
//           description:
//             "We believe the finest journeys come with thoughtful care. Our concierge service is here to make every moment effortless — from arranging local experiences and private transfers to curating special dining or celebration moments. Whether you're an Indian guest or a traveler from afar, our team ensures every detail feels personal and seamless. Just tell us what you need, and we'll make it happen — with warmth, precision, and a touch of Zorba charm.",
//           bannerText: "Explore Concierge services",
//         },
//       },

//       aboutZorba: {
//         title: "About Zorba",

//         heading: "Find your self in nature.",

//         paragraph1:
//           "Zorba was born from the slow realization that everyone we've assisted or known over the years, have all wanted very different kinds of travel experiences. But even with all the differences, what anchored them together was the singular belief in the human & nature connection, a belief that there can be very few pleasures as universal and as pure as the simple feeling of sand between your toes on a beach or the sensation of walking barefoot on fresh green grass.",
//         paragraph2:
//           "This has become our attempt with Zorba Stays, to assist people in having an honest beautiful experience that they've always wanted.",
//         paragraph3:
//           "Zorba Stays is our hope to assist people in exploring the beautiful landscapes of our country, from the warm beaches of Goa to the serene valleys of Uttarakhand and beyond. Whether someone is looking for meditation or a collective celebration- a marriage or a party, we want to invite everyone, as long as they're seeking an honest, beautiful experience. Come explore with us and realize this dream together at Zorba Stays.",
//       },

//       backCover: {
//         logo: "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public",
//         quoteLine1: "Indulge in the extraordinary;",
//         quoteLine2: "life's too short for ordinary",
//         contact: {
//           website: "www.zorbastays.com",
//           email: "info@zorbastays.com",
//           phones: "63552-31066, 98750-28066",
//         },
//       },
//     },
//   ];

//   const Property = QuickBrochureData[0];

//   const handleDownload = () => {
//     window.print();
//   };

//   return (
//     <div className="bg-white min-h-screen flex flex-col items-center py-10 gap-10 print:gap-0 print:py-0 print:p-0 print:bg-[#f8f7f6]">
//       {/* DOWNLOAD BUTTON */}
//       <div className="fixed right-5 bottom-14 flex justify-center py-6 print:hidden">
//         <button
//           onClick={handleDownload}
//           className="flex gap-2 justify-center items-center bg-black text-white w-48 py-3 rounded-md tracking-widest text-sm hover:bg-green-800 transition duration-200 ease-linear"
//         >
//           <FaDownload />
//           Download PDF
//         </button>
//       </div>

//       <div className="fixed right-5 bottom-1 flex justify-center py-6 print:hidden">
//         <button
//           onClick={() => navigate("/Properties")}
//           className="flex gap-2 justify-center items-center border-2 border-black text-black font-semibold w-48 py-2.5 rounded-md tracking-widest text-sm hover:bg-black hover:text-white transition duration-200 ease-linear"
//         >
//           <GiHouse />
//           Back to Properties
//         </button>
//       </div>

//       <style
//         dangerouslySetInnerHTML={{
//           __html: `
//             @page {
//               size: A4 portrait;
//               margin: 0;
//             }

//             @media print {
//               html, body {
//                 width: 210mm;
//                 margin: 0;
//                 padding: 0;
//                 height: auto !important;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }

//               body {
//                 zoom: 100%;
//               }

//               .print-page {
//                 width: 210mm !important;
//                 min-height: 297mm !important;
//                 page-break-after: always;
//                 break-after: page;
//                 page-break-inside: avoid;
//                 break-inside: avoid;
//                 margin: 0 !important;
//               }

//               .print-page:last-of-type {
//                 page-break-after: auto !important;
//                 break-after: auto !important;
//               }

//               .shadow-md {
//                 box-shadow: none !important;
//               }
//             }
//           `,
//         }}
//       />

//       {/* COVER */}
//       <div className="print-page bg-[#f8f7f6] shadow-md w-[210mm] min-h-[297mm] relative flex flex-col items-center p-12">
//         <div className="absolute top-0 left-12 w-[1px] h-80 bg-gray-400"></div>
//         <div className="absolute top-0 left-20 w-[1px] h-60 bg-gray-400"></div>

//         <div className="mt-8 flex flex-col items-center">
//           <img
//             src={Property.villa.logo}
//             alt={Property.villa.title}
//             className="h-28 w-auto object-contain"
//           />
//         </div>

//         <h2 className="mt-20 text-4xl PlayfairDisplay text-gray-800 tracking-wide">
//           {Property.villa.title}
//         </h2>

//         <div className="mt-24 w-full relative group px-4">
//           <p className="montserrat absolute -top-4 right-4 text-[10px] tracking-[0.2em] text-gray-800 uppercase">
//             {Property.villa.text}
//           </p>

//           <div className="w-full aspect-[4/3] bg-gray-200 overflow-hidden">
//             <img
//               src={Property.villa.mainImage}
//               alt={Property.villa.title}
//               className="w-full h-full object-cover"
//             />
//           </div>

//           <div className="absolute -mt-2 right-0 transform z-10">
//             <span className="windsong italic text-5xl text-gray-900">
//               {Property.villa.signature}
//             </span>
//           </div>
//         </div>

//         <div className="montserrat absolute bottom-3">
//           <div className="flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
//             <a
//               href={`https://zorbastays.com/`}
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <span>{Property.villa.contact.website}</span>
//             </a>

//             <span className="h-3 w-[1px] bg-gray-400"></span>

//             <a href={`mailto:info@zorbastays.com`}>
//               <span>{Property.villa.contact.email}</span>
//             </a>

//             <span className="h-3 w-[1px] bg-gray-400"></span>

//             <span>{Property.villa.contact.phones}</span>
//           </div>
//         </div>
//       </div>

//       {/* AMENITIES */}
//       {Array.from(
//         { length: Math.ceil(Property.amenities.items.length / 10) },
//         (_, i) => Property.amenities.items.slice(i * 10, i * 10 + 10),
//       ).map((amenityGroup, pageIndex, allPages) => (
//         <div
//           key={pageIndex}
//           className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 shadow-md relative flex flex-col"
//         >
//           {pageIndex === 0 && (
//             <div className="mt-8 ml-6 flex-none">
//               <h1 className="text-3xl font-serif italic text-gray-800">The</h1>
//               <h2 className="text-5xl PlayfairDisplay tracking-widest text-gray-800 uppercase mt-2">
//                 Amenities
//               </h2>
//             </div>
//           )}

//           <div
//             className={`flex-grow flex items-start justify-center ${pageIndex === 0 ? "pt-20" : "pt-32"}`}
//           >
//             <div className="grid grid-cols-2 gap-y-12 gap-x-12 px-4 w-full">
//               {amenityGroup.map((item, index) => (
//                 <div key={index} className="flex items-center space-x-6">
//                   <div className="w-24 h-24 flex items-center justify-center flex-none">
//                     <img
//                       src={item.imgSrc}
//                       alt={item.name}
//                       className="max-w-full max-h-full object-contain brightness-0 grayscale"
//                     />
//                   </div>
//                   <span className="text-[11px] font-medium tracking-[0.2em] uppercase text-gray-800 leading-tight">
//                     {item.name}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>
//           {pageIndex === allPages.length - 1 && (
//             <div className="mt-auto mb-4 flex justify-center items-center space-x-4">
//               <div className="w-12 h-[1px] bg-gray-400"></div>
//               <div className="w-9 h-9 rounded-full border border-gray-400 flex items-center justify-center">
//                 <img
//                   src={Property.amenities.logo}
//                   alt="logo"
//                   className="w-8 h-5 brightness-0"
//                 />
//               </div>
//               <div className="w-12 h-[1px] bg-gray-400"></div>
//             </div>
//           )}
//         </div>
//       ))}

//       {/* THE VILLA */}
//       <div className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] p-12 pt-20 flex flex-col items-start shadow-md relative overflow-hidden">
//         {(() => {
//           const totalChars =
//             (Property.theVilla.paragraph1?.length || 0) +
//             (Property.theVilla.paragraph2?.length || 0);

//           const imageBottom =
//             totalChars > 600 ? "bottom-[40px]" : "bottom-[170px]";
//           const logoBottom =
//             totalChars > 600 ? "bottom-[20px]" : "bottom-[70px]";

//           return (
//             <>
//               <div className="mb-8 ml-5">
//                 <h1 className="text-3xl font-serif italic text-gray-800 leading-tight">
//                   The
//                 </h1>
//                 <h2 className="text-4xl PlayfairDisplay text-gray-800 uppercase mt-2">
//                   Villa
//                 </h2>
//               </div>

//               <div
//                 className="montserrat flex flex-col ml-5 space-y-6 text-gray-800 tracking-widest text-base text-justify max-w-[92%]"
//                 style={{ wordSpacing: "1px" }}
//               >
//                 <p>{Property.theVilla.paragraph1}</p>
//                 <p>{Property.theVilla.paragraph2}</p>
//               </div>

//               <div
//                 className={`absolute left-12 right-12 h-[430px] z-20 ${imageBottom}`}
//               >
//                 <img
//                   src={Property.theVilla.image}
//                   alt="Villa Exterior"
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               <div
//                 className={`absolute left-8 w-28 h-28 opacity-20 grayscale z-10 ${logoBottom}`}
//               >
//                 <img
//                   src={Property.theVilla.logo}
//                   alt="Logo Watermark"
//                   className="w-full h-full object-contain"
//                 />
//               </div>
//             </>
//           );
//         })()}
//       </div>

//       {/* GALLERY */}
//       {(function () {
//         let pages = [];
//         let i = 0;

//         while (i < Property.villaImages.length) {
//           pages.push({
//             images: Property.villaImages.slice(i, i + 2),
//           });

//           i = i + 2;
//         }

//         return pages.map(function (p, pageIndex) {
//           return (
//             <div
//               key={pageIndex}
//               className="print-page bg-[#f8f7f6] w-[210mm] min-h-[297mm] relative overflow-hidden px-8 pt-16 flex flex-col gap-4 shadow-md"
//             >
//               {p.images.map(function (src, i) {
//                 return (
//                   <div
//                     key={i}
//                     className="flex-1 flex justify-center overflow-hidden"
//                   >
//                     <img
//                       src={src}
//                       alt="villa"
//                       className="w-auto"
//                       style={{ maxHeight: "450px" }}
//                     />
//                   </div>
//                 );
//               })}
//             </div>
//           );
//         });
//       })()}

//       {/* serviceS */}
//       <div className="print-page w-[210mm] min-h-[297mm] px-12 pt-20 flex flex-col relative bg-[#f8f7f6] shadow-md">
//         <div className="mb-12 max-w-[92%] ml-5">
//           <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-6">
//             {Property.services.section1.title}
//           </h2>
//           <p
//             className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-10"
//             style={{ wordSpacing: "1px" }}
//           >
//             {Property.services.section1.description}
//           </p>

//           <div
//             className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-center"
//             style={{
//               backgroundImage:
//                 "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
//             }}
//           >
//             <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
//             <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
//               {Property.services.section1.bannerText}
//             </h3>
//             <a
//               href="https://drive.google.com/file/d/1jOhgd_mzOigpKwZ9ZCWaVt_iyguQlFKa/view"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
//                 Click Here
//               </button>
//             </a>
//           </div>
//         </div>

//         <div className="max-w-[92%] ml-5">
//           <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-10 mt-10">
//             {Property.services.section2.title}
//           </h2>
//           <p
//             className="text-gray-800 montserrat text-[14px] tracking-widest text-justify mb-8"
//             style={{ wordSpacing: "1px" }}
//           >
//             {Property.services.section2.description}
//           </p>

//           <div
//             className="relative w-full h-44 flex flex-col items-center justify-center overflow-hidden rounded-sm bg-cover bg-top"
//             style={{
//               backgroundImage:
//                 "url('https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/6bbede15-8c21-42b1-d91c-cc2fde9f4a00/public')",
//             }}
//           >
//             <div className="absolute inset-0 bg-[#d4dccf] opacity-90"></div>
//             <h3 className="relative z-10 text-2xl font-extrabold text-gray-800 mb-2">
//               {Property.services.section2.bannerText}
//             </h3>
//             <a
//               href="https://drive.google.com/file/d/1jOhgd_mzOigpKwZ9ZCWaVt_iyguQlFKa/view"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <button className="relative z-10 bg-black text-white text-[9px] tracking-widest px-6 py-2 uppercase">
//                 Click Here
//               </button>
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* ABOUT ZORBA */}
//       <div className="print-page w-[210mm] min-h-[297mm] relative flex flex-col pt-10 px-8 overflow-hidden bg-[#f8f7f6] shadow-md">
//         <div className="absolute top-10 right-12 z-20 flex items-center justify-end w-full">
//           <div className="flex-1 h-[1px] bg-gray-400 ml-0"></div>

//           <span className="waterfall italic text-7xl text-gray-800 pl-6">
//             {Property.aboutZorba.title || "About"}
//           </span>
//         </div>

//         <div className="absolute top-32 bottom-0 right-12 w-[1px] bg-gray-400"></div>

//         <div className="flex flex-col justify-center h-full max-w-[95%] pr-16 pl-8 pt-[40vh]">
//           <h2 className="text-4xl PlayfairDisplay text-gray-800 mb-8 leading-tight">
//             {Property.aboutZorba.heading}
//           </h2>

//           <div
//             className="montserrat flex flex-col space-y-8 text-gray-800 text-[15px] tracking-widest text-justify"
//             style={{ wordSpacing: "1px" }}
//           >
//             <p>{Property.aboutZorba.paragraph1}</p>
//             <p>{Property.aboutZorba.paragraph2}</p>
//             <p>{Property.aboutZorba.paragraph3}</p>
//           </div>
//         </div>
//       </div>

//       {/* BACK COVER */}
//       <div className="print-page w-[210mm] min-h-[297mm] flex flex-col justify-between items-center py-16 px-12 bg-[#f8f7f6] shadow-md relative">
//         <div className="flex flex-col items-center mt-60">
//           <img
//             src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9fc19416-6ee2-42fd-bc5a-4f0b5dc29800/public"
//             alt="Logo"
//             className="h-44 w-auto object-contain"
//           />
//         </div>

//         <div className="flex flex-col items-center space-y-32">
//           <div className="text-center">
//             <span className="waterfall text-7xl block leading-tight">
//               {Property.backCover.quoteLine1}
//             </span>
//             <span className="waterfall text-6xl block leading-tight">
//               {Property.backCover.quoteLine2}
//             </span>
//           </div>

//           <div className="montserrat flex justify-center items-center space-x-6 text-[12px] text-gray-500 tracking-[0.2em] font-medium">
//             <a
//               href={`https://zorbastays.com/`}
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               {Property.backCover.contact.website}
//             </a>

//             <span className="h-3 w-[1px] bg-gray-400"></span>

//             <a href={`mailto:info@zorbastays.com`}>
//               {Property.backCover.contact.email}
//             </a>

//             <span className="h-3 w-[1px] bg-gray-400"></span>

//             <span>{Property.backCover.contact.phones}</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default QuickBrochure;
